module.exports = __webpack_public_path__ + "static/media/logo2.ade43dca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo2.svg
// module id = 561
// module chunks = 0